module.exports = __webpack_public_path__ + "static/media/goods2.8e32cc1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/goods2.png
// module id = 1194
// module chunks = 0